import {ActionBrick, registerBrick, ErrorFlow} from 'olympe';
import {getLogger} from '@olympeio/core';
import {extractDataFromSheet, isValidHeader} from './dataFormatHandlers';

export default class ExcelSheetToJSON extends ActionBrick {
    /**
     * @override
     */
    init($) {
        this.logger = getLogger('ExcelSheetToJSON');
    }
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {*} excelSheet
     * @param {string} range
     * @param {Object} params
     * @param {function()} forwardEvent
     * @param {function(Array)} setObjects
     * @param {function(*)} setErrorFlow
     */
    update($, [excelSheet, range, params], [forwardEvent, setObjects, setErrorFlow]) {
        try {
            if (!isValidHeader(range)) {
                throw new Error(`Invalid range: "${range}"`);
            }

            if (!excelSheet && typeof excelSheet !== 'object') {
                throw new Error(`Invalid excelSheet: "${excelSheet}"`);
            }

            const result = extractDataFromSheet(excelSheet, range, params);
            setObjects(result);
            forwardEvent();
        } catch (error) {
            this.logger.error(error.message);
            setErrorFlow(ErrorFlow.create(error, 0));
        }
    }
}

registerBrick('018f0f33714210491de4', ExcelSheetToJSON);
